import Grid from "@mui/material/Grid";
import * as React from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import TelegramIcon from "@mui/icons-material/Telegram";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  CircularProgress,
  Dialog,
  Divider,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { useLocation, useNavigate } from "react-router-dom";
import { getFeed } from "services/apiService";
import { useEffect } from "react";
import { useState } from "react";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import { postUnLike } from "services/apiService";
import { postLike } from "services/apiService";
import { postComment } from "services/apiService";
import LikesDialog from "layouts/dialogModals/LikesDialog";
import CommentsDialog from "layouts/dialogModals/CommentDialog";
import Swal from "sweetalert2";
import Moment from "react-moment";
import InfiniteScroll from "react-infinite-scroll-component";
import { useMediaQuery } from "react-responsive";
import FeedLoader from "components/SkeletonLoader/feedLoader";
import MDButton from "components/MDButton";
import { getPostById } from "services/apiService";
import { useRef } from "react";
import SpinLoader from "components/SpinLoader";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import ShareDialog from "layouts/dialogModals/ShareDialog";
import { getUserInfo } from "services/apiService";
import WalletDialog from "layouts/dialogModals/WalletDialog";

import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import { reportUser } from "services/apiService";
import ReportDialog from "layouts/dialogModals/ReportDialog";
import { toast } from "react-toastify";
import singhCoinCurrency from "assets/images/singhCoinCurrency.png";
import metamaskSvg from "assets/images/metamask-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { feedReducer } from "Store/slices/userFeedSlice";
import { feedReducerPlus } from "Store/slices/userFeedSlice";
import { likeUnLikeCommentReducer } from "Store/slices/userFeedSlice";
import { connectWallet } from "Store/slices/walletSlice";
import { fetchFeed } from "Store/slices/userFeedSlice";
import SuggestionList from "layouts/suggestionBox";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function Dashboard() {
  const dispatch = useDispatch();

  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);

  const { feed, feedCount, feedPageNumber, feedLoading } = useSelector(
    (state) => state.userFeed
  );

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  const { campaignList, campaignLoading, campaignPageNumber } = useSelector(
    (state) => state.campaigns
  );

  const { userAppNotificationCount } = useSelector(
    (state) => state.userSuggestionAndNotifications
  );

  const { balanceReward, isRewardLoading } = useSelector(
    (state) => state.userRewards
  );

  const { isWeb3Enabled, address, chainId, balance, isWalletLoading } =
    useSelector((state) => state.walletData);

  let navigate = useNavigate();
  let location = useLocation();
  // const { web3, isWeb3Enabled, address, enableWeb3, balance, reward } =
  //   useWallet();
  // const [count, setCount] = useState(0);
  // const [post, setPost] = useState([]);
  const [comment, setComment] = useState("");
  const [postId, setPostId] = useState("");
  const [likeDialogBoolean, setLikeDialogBoolean] = useState(false);
  const [commentDialogBoolean, setCommentDialogBoolean] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  // const [feedLoading, setFeedLoading] = useState(true);
  const [shareDialogBoolean, setShareDialogBoolean] = useState(false);
  const [type, setType] = useState("");
  // const [userInfo, setUserInfo] = useState("");
  const [walletDialogBoolean, setWalletDialogBoolean] = useState(false);

  const [reportDialogBoolean, setReportDialogBoolean] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  // const [pageNumber,setPageNumber]=useState(1)

  const handleConnectWallet = (providerApi) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (address === "") {
      dispatch(connectWallet(providerApi));
    } else {
      setWalletDialogBoolean(true);
    }
  };

  useEffect(() => {
    fetchGetFeed();
  }, []);

  const fetchGetFeed = async () => {
    dispatch(fetchFeed(1));
  };

  const fetchMoreData = async (postPageNumber) => {
    // console.log("here");

    const getFeedResNew = await getFeed(feedPageNumber + 1);
    dispatch(feedReducerPlus(getFeedResNew));

    setPageNumber((prev) => prev + 1);
  };

  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  const handleLikeUnLike = async (isLikedBoolean, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    const postID = {
      postID: postId,
    };
    if (isLikedBoolean) {
      const postUnlikeRes = await postUnLike(postID);
      const postByIdRes = await getPostById(postId);
      dispatch(likeUnLikeCommentReducer(postByIdRes[0]));
    } else {
      const postLikeRes = await postLike(postID);
      const postByIdRes = await getPostById(postId);
      dispatch(likeUnLikeCommentReducer(postByIdRes[0]));
    }
  };

  const handleInputChange = (value, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setComment({
      [postId]: value,
    });
  };

  const handlePostComment = async (postId) => {
    if (comment === "") {
    }

    const postComData = {
      comment: comment[postId],
      postID: postId,
    };

    const postComRes = await postComment(postComData);
    // console.log("postComRes", postComRes);
    setComment("");

    const postByIdRes = await getPostById(postId);
    // console.log("postByid", postByIdRes);

    dispatch(likeUnLikeCommentReducer(postByIdRes[0]));
  };

  const openLikesDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setLikeDialogBoolean(true);
  };

  const handleCloseLikeDialog = () => {
    setLikeDialogBoolean(false);
  };

  const openCommentsDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setCommentDialogBoolean(true);
  };

  const handleCloseCommentDialog = () => {
    setCommentDialogBoolean(false);
  };

  const handleFindFriends = () => {
    navigate("/search");
  };

  const handlecampaign = () => {
    navigate("/campaigns");
  };

  const handleVideoClick = (item) => {
    navigate(`/reels`, { state: item });
  };

  const handleShare = (type, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setType(type);
    setPostId(postId);
    setShareDialogBoolean(true);
  };

  const handleCloseShareDialog = () => {
    setShareDialogBoolean(false);
  };

  const handleCloseWalletDialog = () => {
    setWalletDialogBoolean(false);
  };

  const handleReport = async (uselessState, reportType, reportIdentifier) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    if (reportType === "post") {
      setPostId(reportIdentifier);
      setReportDialogBoolean(true);
    } else {
      const reportUserRes = await reportUser(reportIdentifier);
      // console.log("reportUserRes", reportUserRes);

      if (reportUserRes.status === 200) {
        Swal.fire({
          title: "Thank you reporting",
          text: "We will review and take the nexessary action against this.",
          icon: "success",
          background: "darkgray",
          width: "360px",
          // confirmButtonText: "Remove",
          // confirmButtonColor: "red",
          // showCancelButton: true,
        });
      } else {
        toast.error(`Something went wrong, Please try again`, {
          style: {
            fontSize: "15px",
          },
        });
      }
    }
  };

  const handleCloseReportDialog = () => {
    setReportDialogBoolean(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      {isTabletOrMobile && (
        <MDBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <MDButton
            // sx={{ borderRadius: "20px" }}
            color="singh"
            variant="outlined"
            startIcon={
              <img
                src={singhCoinCurrency}
                style={{ objectFit: "contain" }}
                height="20px"
                alt="currentSymbol"
              />
            }
          >
            <MDTypography fontSize="inherit" color="inherit">
              {isRewardLoading ? (
                <CircularProgress size={15} color="inherit" />
              ) : balanceReward !== 0 ? (
                Number(balanceReward).toFixed(2)
              ) : (
                balanceReward
              )}
              {/* {reward.rewardInSingh != null
                ? Number(reward.rewardInSingh).toFixed(2)
                : reward} */}
            </MDTypography>
          </MDButton>

          <MDButton
            // sx={{ borderRadius: "20px" }}
            color="singh"
            variant="outlined"
            startIcon={
              <img
                src={metamaskSvg}
                style={{ objectFit: "contain" }}
                height="15px"
                alt="currentSymbol"
              />
            }
            onClick={() => handleConnectWallet("ethereum")}
          >
            <MDTypography fontSize="inherit" color="inherit">
              {isWalletLoading ? (
                <CircularProgress size={15} color="inherit" />
              ) : isWeb3Enabled ? (
                Number(balance).toFixed(2)
              ) : (
                "Connect Wallet"
              )}

              {/* {isWeb3Enabled && address && balance !== undefined
                ? Number(balance).toFixed(2)
                : "Connect wallet"} */}
            </MDTypography>
          </MDButton>
        </MDBox>
      )}

      <MDBox
        // py={3}
        sx={{ paddingTop: 0, marginTop: 3 }}
      >
        <MDBox>
          <Grid container justifyContent="space-between">
            <Grid
              item
              xs={12}
              // md={5.5}
              lg={5.5}
              sx={{ marginLeft: isTabletOrMobile ? null : 13 }}
            >
              <InfiniteScroll
                dataLength={feed.length}
                next={() => fetchMoreData(pageNumber)}
                hasMore={feed.length < feedCount}
                loader={
                  <MDBox sx={{ marginTop: "1rem", textAlign: "center" }}>
                    <SpinLoader />
                  </MDBox>
                }
              >
                {feedLoading ? (
                  <FeedLoader />
                ) : feed.length > 0 ? (
                  feed.map((item, idx) => (
                    <MDBox mb={3} key={idx} sx={{}}>
                      <Card sx={{}}>
                        <CardHeader
                          sx={{ padding: "10px" }}
                          avatar={
                            <MDAvatar
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleUsernameClick(item.username)}
                              src={item.pic}
                              imgProps={{
                                style: { height: "100%", width: "100%" },
                              }}
                            />
                          }
                          title={
                            <MDTypography
                              fontWeight="bold"
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleUsernameClick(item.username)}
                            >
                              {item.username}
                            </MDTypography>
                          }
                          action={
                            localStorage.userNameSingh !== item.username && (
                              <PopupState
                                variant="popover"
                                popupId="demo-popup-menu"
                              >
                                {(popupState) => (
                                  <>
                                    <IconButton {...bindTrigger(popupState)}>
                                      <MoreVertIcon sx={{ color: "#fff" }} />
                                    </IconButton>
                                    <Menu {...bindMenu(popupState)}>
                                      <MenuItem
                                        onClick={() =>
                                          handleReport(
                                            popupState.close(),
                                            "post",
                                            item._id
                                          )
                                        }
                                      >
                                        Report
                                      </MenuItem>
                                      <MenuItem
                                        onClick={() =>
                                          handleReport(
                                            popupState.close(),
                                            "account",
                                            item.username
                                          )
                                        }
                                      >
                                        Report Account
                                      </MenuItem>
                                    </Menu>
                                  </>
                                )}
                              </PopupState>
                            )
                          }
                        />
                        <MDBox
                          // onClick={handleVideo}
                          sx={{ height: "400px" }}
                        >
                          {item.postType === "video" ? (
                            <>
                              <video
                                onClick={() => handleVideoClick(item)}
                                // ref={videoRef}
                                height="100%"
                                width="100%"
                                style={{
                                  cursor: "pointer",
                                  position: "relative",
                                }}
                                // src={item.photo}
                                // autoPlay
                                // loop
                                // muted
                                // controls
                                poster={item.thumbnail}
                              >
                                <source src={item.photo} type="video/mp4" />
                              </video>
                              <MDTypography
                                fontSize="50px"
                                sx={{ cursor: "pointer" }}
                                onClick={() => handleVideoClick(item)}
                              >
                                <PlayCircleOutlineIcon
                                  sx={{
                                    position: "absolute",
                                    top: "40%",
                                    right: "47%",
                                  }}
                                />
                              </MDTypography>
                            </>
                          ) : (
                            <img
                              // style={{ objectFit: "contain" }} // height and noObjectfit
                              src={item.photo}
                              height="100%"
                              width="100%"
                              alt="image"
                            />
                          )}
                        </MDBox>

                        <CardActions disableSpacing>
                          <MDBox sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton
                              aria-label="add to favorites"
                              onClick={() =>
                                handleLikeUnLike(item.isLiked, item._id)
                              }
                            >
                              {item.isLiked ? (
                                <FavoriteIcon style={{ color: "red" }} />
                              ) : (
                                <FavoriteBorderIcon style={{ color: "#fff" }} />
                              )}
                            </IconButton>
                            <MDTypography
                              fontWeight="bold"
                              sx={{ cursor: "pointer" }}
                              onClick={() => openLikesDialog(item._id)}
                            >
                              {item.totalLike}
                            </MDTypography>
                          </MDBox>
                          <MDBox sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton
                              onClick={() => openCommentsDialog(item._id)}
                            >
                              <ChatBubbleOutlineIcon
                                style={{ color: "#fff" }}
                              />
                            </IconButton>
                            <MDTypography
                              fontWeight="bold"
                              sx={{ cursor: "pointer" }}
                              onClick={() => openCommentsDialog(item._id)}
                            >
                              {item.totalComment}
                            </MDTypography>
                          </MDBox>
                          <MDBox sx={{ display: "flex", alignItems: "center" }}>
                            <IconButton
                              onClick={() => handleShare("post", item._id)}
                            >
                              <TelegramIcon style={{ color: "#fff" }} />
                            </IconButton>
                          </MDBox>
                        </CardActions>
                        <CardContent
                          sx={{
                            paddingTop: 0,
                            paddingBottom: 0,
                            paddingLeft: 2.5,
                            paddingRight: 2.5,
                            marginBottom: "0.5rem",
                          }}
                        >
                          <MDTypography
                            fontWeight="bold"
                            fontSize="15px"
                            whiteSpace="pre-wrap"
                          >
                            {item.caption}
                          </MDTypography>
                          <MDTypography fontSize="15px" sx={{ color: "grey" }}>
                            <Moment fromNow>{item.updatedTime}</Moment>
                          </MDTypography>
                        </CardContent>

                        <MDBox
                          sx={{
                            p: "2px 4px",
                            display: "flex",
                            alignItems: "center",
                            borderTop: "0.5px solid #333333",
                          }}
                        >
                          <IconButton sx={{ p: "5px" }}>
                            <MDAvatar
                              src={userAppInfo?.profilePic}
                              sx={{
                                cursor: "pointer",
                                width: "2rem",
                                height: "2rem",
                              }}
                              imgProps={{
                                style: { height: "100%", width: "100%" },
                              }}
                            />
                          </IconButton>
                          <InputBase
                            sx={{
                              ml: 1,
                              flex: 1,
                              fontSize: "18px",
                            }}
                            multiline
                            placeholder="Add a comment..."
                            inputProps={{ style: { color: "#6a6a6a" } }}
                            value={comment[item._id] || ""}
                            onChange={(e) =>
                              handleInputChange(e.target.value, item._id)
                            }
                          />

                          <IconButton
                            disabled={
                              comment === "" || !/\S/.test(comment[item._id])
                            }
                            sx={{}}
                            onClick={() => handlePostComment(item._id)}
                          >
                            <MDTypography
                              sx={{
                                color:
                                  comment === "" ||
                                  !/\S/.test(comment[item._id])
                                    ? "grey"
                                    : "",
                                fontSize: "18px",
                              }}
                            >
                              Post
                            </MDTypography>
                          </IconButton>
                        </MDBox>
                      </Card>
                    </MDBox>
                  ))
                ) : (
                  <MDBox sx={{ textAlign: "center" }}>
                    <MDBox sx={{ marginBottom: "3rem" }}>
                      <MDTypography
                        sx={{ fontSize: "28px", marginBottom: "1rem" }}
                      >
                        Welcome to SinghCoin
                      </MDTypography>
                      <MDTypography sx={{ fontSize: "19px" }}>
                        Follow people to start seeing the feeds they share
                      </MDTypography>
                    </MDBox>
                    <MDBox sx={{ marginBottom: "1rem" }}>
                      <MDButton
                        sx={{ width: isTabletOrMobile ? "82%" : "64%" }}
                        color="singh"
                        onClick={handleFindFriends}
                      >
                        Find Friends
                      </MDButton>
                    </MDBox>
                    <MDBox sx={{ marginBottom: "1rem" }}>
                      <MDTypography fontSize="15px">OR</MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDButton
                        variant="outlined"
                        color="singh"
                        onClick={handlecampaign}
                      >
                        Have a look at our amazing campaigns
                      </MDButton>
                    </MDBox>
                  </MDBox>
                )}
              </InfiniteScroll>
            </Grid>
            {isDesktopOrLaptop && loginStatus && (
              <Grid item xs={4}>
                <MDBox width="100%" marginBottom="1rem">
                  <Card
                    sx={{ backgroundColor: "#1a1a1a", cursor: "pointer" }}
                    onClick={() => handleUsernameClick(userAppInfo.username)}
                  >
                    <MDBox
                      textAlign="center"
                      // variant="gradient"
                      // bgColor="info"
                      borderRadius="lg"
                      // coloredShadow="info"
                      mx={2}
                      mt={2}
                      sx={{
                        // marginTop: "14px",
                        background: "linear-gradient(195deg, #1a1a1a, #08080c)",
                        boxShadow:
                          "0rem 0.25rem 1.25rem 0rem rgba(0, 0, 0, 0.14), 0rem 0.4375rem 0.625rem -0.3125rem rgb(113 113 113 / 40%)",
                      }}
                      p={2}
                      // mb={1}
                    >
                      <MDBox
                        sx={{ textAlign: "-webkit-center" }}
                        // variant="h4"
                        // fontWeight="medium"
                        // color="white"
                        mt={4}
                      >
                        <MDAvatar
                          // alt="Remy Sharp"
                          src={userAppInfo?.profilePic}
                          sx={{
                            cursor: "pointer",
                            width: "3.5rem",
                            height: "3.5rem",
                          }}
                          imgProps={{
                            style: { height: "100%", width: "100%" },
                          }}
                        />
                      </MDBox>
                      <MDTypography
                        variant="h5"
                        fontWeight="medium"
                        color="white"
                        mt={1}
                      >
                        {userAppInfo?.username}
                      </MDTypography>
                      <MDTypography
                        variant="h6"
                        fontWeight="medium"
                        color="white"
                        mt={1}
                      >
                        {userAppInfo?.fullName}
                      </MDTypography>
                      <Divider />
                      <Grid
                        container
                        spacing={4}
                        justifyContent="center"
                        sx={{ mb: 2 }}
                      >
                        <Grid item xs={5}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            color="white"
                            mt={1}
                          >
                            {userAppInfo?.following}
                          </MDTypography>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            color="white"
                            sx={{ fontSize: "0.875rem" }}
                          >
                            Following
                          </MDTypography>
                        </Grid>

                        <Grid item xs={5}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            color="white"
                            mt={1}
                          >
                            {userAppInfo?.followers}
                          </MDTypography>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            color="white"
                            sx={{ fontSize: "0.875rem" }}
                          >
                            Followers
                          </MDTypography>
                        </Grid>
                      </Grid>
                      <Divider />
                    </MDBox>
                    <MDBox pt={2} pb={3} px={3} sx={{ textAlign: "center" }}>
                      <MDBox>
                        <MDBox mb={1}>
                          <MDTypography
                            variant="h6"
                            fontWeight="medium"
                            sx={{ color: "#f5d244", fontSize: "0.875rem" }}
                          >
                            My Profile
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>

                <MDBox width="100%" sx={{ position: "sticky", top: 80 }}>
                  <Card
                    sx={{
                      height: "100%",
                      // marginTop: "1rem",
                      // paddingRight: "1rem",
                      // paddingLeft: "1rem",
                      padding: "1rem",
                    }}
                  >
                    <SuggestionList
                      title="Suggestions for you"
                      shadow={false}
                    />
                    <MDBox sx={{ marginTop: "1rem" }}>
                      <Footer />
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            )}
          </Grid>
        </MDBox>

        {walletDialogBoolean && (
          <WalletDialog
            openStatus={walletDialogBoolean}
            onClose={() => handleCloseWalletDialog()}
            // postId={postId}
            // type={type}
          />
        )}

        {reportDialogBoolean && (
          <ReportDialog
            openStatus={reportDialogBoolean}
            onClose={() => handleCloseReportDialog()}
            postId={postId}
          />
        )}

        {shareDialogBoolean && (
          <ShareDialog
            openStatus={shareDialogBoolean}
            onClose={() => handleCloseShareDialog()}
            postId={postId}
            type={type}
          />
        )}

        {likeDialogBoolean && (
          <LikesDialog
            openStatus={likeDialogBoolean}
            onClose={() => handleCloseLikeDialog()}
            postId={postId}
          />
        )}

        {commentDialogBoolean && (
          <CommentsDialog
            openStatus={commentDialogBoolean}
            onClose={() => handleCloseCommentDialog()}
            postId={postId}
          />
        )}
      </MDBox>
      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default Dashboard;
